import { component } from 'picoapp'
import '@/lib/jquery-global.js';
import 'slick-carousel'

export default component((node, ctx) => {
  
    var slider = $('.js-mobile-slider');

    slider.slick({
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        prevArrow: $(".prev-arrow"),
        nextArrow: $('.next-arrow')
    });
    
})
